import { ThemeProvider as NextThemesProvider, type ThemeProviderProps } from 'next-themes';
import type { JSX } from 'react';

/**
 * App-wide theme provider.
 *
 * - Class-based dark mode (`class="dark"` on <html>) — matches our globals.css `.dark` block.
 * - Defaults to "system"; explicit user choice persists in localStorage["aryan-theme"].
 * - `disableTransitionOnChange` prevents the classic "flicker on toggle" by injecting a no-
 *   transition style snapshot during the swap. This is required for Phase 3 success criterion 2.
 */
export function ThemeProvider({ children, ...props }: ThemeProviderProps): JSX.Element {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey="aryan-theme"
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
